import React, { Component } from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import moment from "moment";
import { DiscussionEmbed } from "disqus-react";

import Layout from "../components/layout";
import SEO from "../components/seo";
import Share from "../components/share";

export default class blogPost extends Component {
  render() {
    const data = this.props.data.contentfulBlogs;
    const { nexttitle, nextslug, prevtitle, prevslug } = this.props.pageContext;

    const siteurl = this.props.data.contentfulSiteInformation.siteUrl + "/";
    const twiteerhandle = this.props.data.contentfulSiteInformation
      .twiteerHandle;
    const socialConfigss = {
      site: {
        siteMetadata: { siteurl, twiteerhandle }
      },
      title: data.title,
      slug: data.slug
    };

    let html = data.description.childMarkdownRemark.html;

    // strip questions
    html = html.replace("How will you enjoy the game of life and take control of your schedule? What's one thing you've always wanted to do in life but have been putting off? When are you going to do it?", '');

    return (
      <Layout>
        <SEO
          title={data.title}
          keywords={[
            `${data.title}`
          ]}
        />
        <div className="site-container blog-post">
          <div className="container">
            {data.featureImage ? (
              <Img
                className="feature-img"
                fluid={data.featureImage.fluid}
                imgStyle={{ objectFit: 'contain' }}
              />
            ) : (
              <div className="no-image"></div>
            )}

            <div className="details">
              <div
                dangerouslySetInnerHTML={{
                  __html: data.description.childMarkdownRemark.html
                }}
              />
            </div>
            <nav>
              <ul className="pagination">
                <li>
                  <Link to={prevslug} rel="prev">
                    ← {prevtitle}
                  </Link>
                </li>
                <li>
                  <Link to={nextslug} rel="next">
                    {nexttitle}→
                  </Link>
                </li>
              </ul>
            </nav>
            <Share
              socialConfig={{
                ...socialConfigss.site.siteMetadata.twiteerhandletitle,
                config: {
                  url: `${siteurl}${socialConfigss.slug}`,
                  title: `${socialConfigss.title}`
                }
              }}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query SinglePostQuery($slug: String!, $userid: String!) {
    contentfulBlogs(userid: { eq: $userid }, slug: { eq: $slug }) {
      id
      title
      slug
      featureImage {
        fluid(maxHeight: 900) {
          base64
          aspectRatio
          src
          srcSet
          srcWebp
          srcSetWebp
          sizes
        }
      }
      description {
        childMarkdownRemark {
          html
        }
      }
      createdAt
      rank
    }
    contentfulSiteInformation {
      siteUrl
      twiteerHandle
    }
  }
`;
